import { cn } from "@/lib/utils";
import Image from "next/image";
import { ComponentProps } from "react";

type ProductGalleryImageProps = {
  src: string;
  alt: string;
  index: number;
} & ComponentProps<typeof Image>;

export default function ProductGalleryImage({
  src,
  alt,
  index,
  className,
  ...rest
}: ProductGalleryImageProps) {
  return (
    <Image
      className={cn("w-full mix-blend-multiply", className)}
      src={src}
      alt={alt}
      width={1000}
      height={1000}
      priority={index === 0}
      fetchPriority={index === 0 ? "high" : "low"}
      loading={index === 0 ? undefined : "lazy"}
      sizes="(min-width: 768px) 60vw, 100vw"
      {...rest}
    />
  );
}
